import { tenantAwareApiWrapper, withOrchestratorClient } from './portal-http';
import { assetsSearchClient } from '@terra/shared-rest-clients-assets';
import { endpointsClient } from '@terra/shared-rest-clients-endpoints';
import { webPagesClient } from '@terra/shared-rest-clients-web-pages';
import type {
  AssetsSearchBodyDto,
  AssetsSearchContract,
  AssetsSearchMetricsBodyDto,
} from '@terra/shared-contracts-assets';
import type { EndpointsContract } from '@terra/shared-contracts-endpoints';
import type { WebPagesContract } from '@terra/shared-contracts-web-pages';

export const portalAssetTableApi = {
  searchApplicationAssets: ({
    applicationId,
    body,
  }: {
    applicationId: string;
    body: AssetsSearchBodyDto;
  }) =>
    tenantAwareApiWrapper<typeof AssetsSearchContract.searchAssets>({
      endpointFn: (headers) =>
        assetsSearchClient.searchAssets({
          params: { applicationId },
          body,
          ...withOrchestratorClient(headers),
        }),
    }),

  exportApplicationAssets: ({
    applicationId,
    body,
  }: {
    applicationId: string;
    body: AssetsSearchBodyDto;
  }) =>
    tenantAwareApiWrapper<typeof AssetsSearchContract.exportAssets>({
      endpointFn: (headers) =>
        assetsSearchClient.exportAssets({
          params: { applicationId },
          body,
          ...withOrchestratorClient(headers),
        }),
    }),

  getApplicationAssetsMetrics: ({
    applicationId,
    body,
  }: {
    applicationId: string;
    body: AssetsSearchMetricsBodyDto;
  }) =>
    tenantAwareApiWrapper<typeof AssetsSearchContract.getAssetsMetrics>({
      endpointFn: (headers) =>
        assetsSearchClient.getAssetsMetrics({
          params: { applicationId },
          body,
          ...withOrchestratorClient(headers),
        }),
    }),

  getEndpointDetections: (endpointId: string) =>
    tenantAwareApiWrapper<typeof EndpointsContract.getEndpointDetections>({
      endpointFn: (headers) =>
        endpointsClient.getEndpointDetections({
          params: { id: endpointId },
          ...withOrchestratorClient(headers),
        }),
    }),

  getEndpointRelatedWebpages: ({
    endpointId,
    limit,
  }: {
    endpointId: string;
    limit?: number;
  }) =>
    tenantAwareApiWrapper<typeof EndpointsContract.getEndpointWebpages>({
      endpointFn: (headers) =>
        endpointsClient.getEndpointWebpages({
          params: { id: endpointId },
          query: { limit },
          ...withOrchestratorClient(headers),
        }),
    }),

  getWebpageRelatedEndpoints: ({
    webpageId,
    limit,
  }: {
    webpageId: string;
    limit?: number;
  }) =>
    tenantAwareApiWrapper<typeof WebPagesContract.getWebpageEndpoints>({
      endpointFn: (headers) =>
        webPagesClient.getWebpageEndpoints({
          params: { id: webpageId },
          query: { limit },
          ...withOrchestratorClient(headers),
        }),
    }),
};
